// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const delibird: PokeData = {
  "id": 225,
  "name": "delibird",
  "height": 9,
  "weight": 160,
  "base_experience": 116,
  "types": [
    PokeType.ICE,
    PokeType.FLYING
  ],
  "api_moves": [
    "drill-peck",
    "present"
  ],
  "moves": [
    "ice-shard",
    "gust",
    "aerial-ace",
    "brave-bird",
    "aurora-veil",
    "hailstorm",
    "ice-wave",
    "sky-attack",
    "ice-punch",
    "tailwind",
    "air-slash",
    "acrobatics",
    "roost"
  ],
  "evolution_chain": {
    "id": 115,
    "item": null,
    "species": [
      {
        "name": "delibird",
        "order": 257,
        "types": [
          PokeType.ICE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 90,
    "speed": 150,
    "ability_power": 130
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
